import { createContext, useContext, useState } from "react";

export const CartContext = createContext(null);
export const StateContext = createContext(null);
export const SearchContext = createContext(null);

export function useCart() {
  const ctx = useContext(CartContext);
  if (!ctx) throw new Error("useCart must be used inside CartContext.Provider");
  return ctx;
}

export function useAppState() {
  const ctx = useContext(StateContext);
  if (!ctx) throw new Error("useAppState must be used inside StateContext.Provider");
  return ctx;
}

export function useSearch() {
  const ctx = useContext(SearchContext);
  if (!ctx) throw new Error("useSearch must be used inside SearchProvider");
  return ctx;
}

export const SearchProvider = ({ children }) => {
  const [query, setQueryState] = useState("");
  const [searchEventId, setSearchEventId] = useState(null);

  const setQuery = (value) => {
    setQueryState(value);
    setSearchEventId(null);
  };

  return (
    <SearchContext.Provider value={{ query, setQuery, searchEventId, setSearchEventId }}>
      {children}
    </SearchContext.Provider>
  );
};
